import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessSummaryRoute: InvariantJiraRoute = {
	name: 'classic-business-summary',
	path: '/jira/core/projects/:projectKey/summary',
	exact: true,
};
